import React, { Component } from 'react';
import ErrorBoundaryMessage from '@rsos/components/capstone/DataCards/ErrorBoundaryMessage';
import { captureExceptionWithScope } from '@rsos/utils/sentry';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // TODO: custom sentry error to indicate it's a malformatted display schema issue pertaining to a call
    captureExceptionWithScope(error, {
      boundaryName: 'EllingtonCard#ErrorBoundary',
      stackTrace: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryMessage />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
